/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
import React from "react";
import { classNames } from "@plasmicapp/react-web";

export type Icon98IconProps = React.ComponentProps<"svg"> & {
  title?: string;
};

export function Icon98Icon(props: Icon98IconProps) {
  const { className, style, title, ...restProps } = props;
  return (
    <svg
      xmlns={"http://www.w3.org/2000/svg"}
      fill={"none"}
      viewBox={"0 0 32 32"}
      height={"1em"}
      className={classNames("plasmic-default__svg", className)}
      style={style}
      {...restProps}
    >
      {title && <title>{title}</title>}

      <path
        fill={"currentColor"}
        d={
          "M5.294 25.292a1 1 0 1 1 1.414 1.414l-4.001 4.001a1 1 0 1 1-1.414-1.414l4-4.001zm7.999-11.999a1 1 0 1 1 1.414 1.414l-3 3a1 1 0 1 1-1.414-1.414zm4 4a1 1 0 1 1 1.414 1.414l-3 3a1 1 0 1 1-1.414-1.414z"
        }
      ></path>

      <path
        fill={"currentColor"}
        d={
          "M7.539 13.393a1 1 0 0 1 1.337.069l9.662 9.663a1 1 0 0 1 0 1.414l-2.166 2.168a7.835 7.835 0 0 1-13.373-5.539c0-2.078.825-4.07 2.294-5.539l2.17-2.167.076-.07zm-2.54 7.775a5.834 5.834 0 0 0 9.957 4.125l1.46-1.46-8.249-8.25-1.46 1.46A5.83 5.83 0 0 0 5 21.168zM29.293 1.293a1 1 0 1 1 1.414 1.414l-4.001 4.001a1 1 0 1 1-1.414-1.414l4-4.001z"
        }
      ></path>

      <path
        fill={"currentColor"}
        d={
          "M27.001 10.832a5.833 5.833 0 0 0-9.958-4.124l-.001-.001-1.46 1.46 8.25 8.25 1.461-1.46.2-.21A5.83 5.83 0 0 0 27 10.833zm2 0c0 1.947-.725 3.82-2.026 5.257l-.268.283-2.169 2.167a1 1 0 0 1-1.414 0l-9.662-9.663a1 1 0 0 1 0-1.414l2.167-2.17A7.834 7.834 0 0 1 29 10.833z"
        }
      ></path>
    </svg>
  );
}

export default Icon98Icon;
/* prettier-ignore-end */
